export const toModList = (mods) => (!mods ? [] : Array.isArray(mods) ? mods : [mods]);

export const isCareerMod = (mod) => mod?.isCareer === true || mod?.isCareer === "true";

export const speciesSkillMods = (species) => {
    if (!species) return [];
    const sub = species.SubSpecies && Array.isArray(species.SubSpeciesList)
        ? species.SubSpeciesList.find((ss) => ss.Key === species.SubSpecies)
        : null;
    return [...toModList(species.SkillModifiers), ...toModList(sub?.SkillModifiers)];
};

export const modTargetSkills = (mod, skills) => {
    if (mod?.Key) return skills.filter((s) => s.Key === mod.Key);
    if (mod?.SkillType) return skills.filter((s) => s.type === mod.SkillType);
    return [];
};

export const isSpeciesCareerSkill = (species, skillData, skills) =>
    !!skillData && speciesSkillMods(species).some(
        (mod) => isCareerMod(mod) && modTargetSkills(mod, skills).some((s) => s.Key === skillData.Key)
    );

export const describeSkillMod = (mod, skills) => {
    const ranks = parseInt(mod?.RankStart) || 0;
    const limit = mod?.RankLimit || "2";
    const lines = [];
    if (mod?.Key) {
        const name = skills.find((s) => s.Key === mod.Key)?.skill;
        if (!name) return lines;
        if (ranks > 0) lines.push(`Begins with ${ranks} rank in ${name}. They may not train this skill above ${limit} ranks at creation.`);
        if (isCareerMod(mod)) lines.push(`${name} is a career skill.`);
    } else if (mod?.SkillType) {
        if (ranks > 0) lines.push(`Begins with ${ranks} rank in all ${mod.SkillType} skills. They may not train these skills above ${limit} ranks at creation.`);
        if (isCareerMod(mod)) lines.push(`Begin with all ${mod.SkillType} skills as career skills.`);
    }
    return lines;
};
